class UserInfo {
  /**
   *
   * @param {?object} [userInfoData]
   */
  constructor(userInfoData) {
    this.data = null;

    if (userInfoData) {
      this.data = userInfoData;
    }
  }

  /**
   *
   * @param {string} objType
   * @param {string} id
   * @returns {object}
   * @private
   */
  _getObj(objType, id) {
    this._verifyExists(objType, id);
    return this.data[objType][id];
  }

  /**
   *
   * @param {string} objType
   * @param {string} id
   * @private
   */
  _verifyExists(objType, id) {
    if (!this.data[objType][id])
      throw new Error(`UserInfo - ERROR - ${objType} does not exist: ${id}`);
  }

  /**
   *
   * @returns {boolean}
   */
  hasLoaded() {
    return !!this.data;
  }

  /**
   *
   * @returns {boolean}
   */
  hasSelectedLeagueSeason() {
    return !!this.getSelectedLeagueSeasonObj();
  }

  /**
   *
   * @returns {boolean}
   */
  hasSelectedTeam() {
    return !!this.getSelectedTeamObj();
  }

  /**
   *
   * @returns {?object}
   */
  getSelectedTeamObj() {
    let team = null;
    try {
      team = this.getTeamObj(this.data?.user?.selectedTeam);
    } catch (err) {}

    return team;
  }

  /**
   *
   * @returns {?object}
   */
  getSelectedLeagueSeasonObj() {
    let leagueSeason = null;
    try {
      leagueSeason = this.getLeagueSeasonObj(
        this.data?.user?.selectedLeagueSeason
      );
    } catch (err) {}

    return leagueSeason;
  }

  /**
   *
   * @param {string} divisionId
   * @returns {object}
   */
  getDivisionObj(divisionId) {
    return this._getObj("divisions", divisionId);
  }

  /**
   *
   * @param {string} divisionSeasonId
   * @returns {object}
   */
  getDivisionSeasonObj(divisionSeasonId) {
    return this._getObj("divisionSeasons", divisionSeasonId);
  }

  /**
   *
   * @param {string} franchiseId
   * @returns {object}
   */
  getFranchiseObj(franchiseId) {
    return this._getObj("franchises", franchiseId);
  }

  /**
   *
   * @param {string} leagueId
   * @returns {object}
   */
  getLeagueObj(leagueId) {
    return this._getObj("leagues", leagueId);
  }

  /**
   *
   * @param leagueIdOrSlug
   * @returns {?object}
   */
  getLeagueObjFromIdOrSlug(leagueIdOrSlug) {
    let leagueObj = null;
    if (this.data) {
      if (this.data.leagues[leagueIdOrSlug]) {
        leagueObj = this.data.leagues[leagueIdOrSlug];
      } else {
        let leagues = Object.keys(this.data.leagues)
          .map((leagueId) => this.data.leagues[leagueId])
          .filter((league) => league.slug === leagueIdOrSlug);
        if (leagues.length === 1) {
          leagueObj = leagues[0];
        }
      }
      if (!leagueObj) {
        console.error(
          `Cannot get league obj from slug or id: ${leagueIdOrSlug}`
        );
      }
    }
    return leagueObj;
  }

  /**
   *
   * @param {string} leagueSeasonId
   * @returns {object}
   */
  getLeagueSeasonObj(leagueSeasonId) {
    return this._getObj("leagueSeasons", leagueSeasonId);
  }

  /**
   *
   * @param {string} teamId
   * @returns {object}
   */
  getTeamObj(teamId) {
    return this._getObj("teams", teamId);
  }

  /**
   *
   * @param {string} teamIdOrSlug
   * @param {string} leagueSeasonId
   * @returns {?object}
   */
  getTeamObjFromIdOrSlug(teamIdOrSlug, leagueSeasonId) {
    let teamObj = null;
    if (this.data) {
      if (this.data.teams[teamIdOrSlug]) {
        teamObj = this.data.teams[teamIdOrSlug];
      } else if (leagueSeasonId) {
        let teams = Object.keys(this.data.teams)
          .map((teamId) => this.data.teams[teamId])
          .filter(
            (team) =>
              team.slug === teamIdOrSlug && team.leagueSeason === leagueSeasonId
          );
        if (teams.length === 1) {
          teamObj = teams[0];
        }
      }
      if (!teamObj) {
        console.error(
          `Cannot get team obj from slug or id: ${teamIdOrSlug} & leagueSeasonId: ${leagueSeasonId}`
        );
      }
    }

    return teamObj;
  }

  /**
   *
   * @returns {object}
   */
  getUserObj() {
    return this.data.user;
  }
}

export default UserInfo;
